import { Divider, Text } from '@innovationdepartment/proxima-ui';
import type { CreateSeedAudiencesDataSourceProps } from 'types/audiences';
import ContentContainer from '../ContentContainer';
import CreateSeedAudiencesDataSourceConnectionBadge from './CreateSeedAudiencesDataSource.ConnectionBadge';
import CreateSeedAudiencesDataSourcesBrandCategory from './CreateSeedAudiencesDataSources.BrandCategory';
import CreateSeedAudiencesDataSourcesCategoryShoppers from './CreateSeedAudiencesDataSources.CategoryShoppers';
import CreateSeedAudiencesDataSourcesCOLALs from './CreateSeedAudiencesDataSources.COLALs';
import { ContentWrapper } from './Layout';

const CreateSeedAudiencesDataSourcesView = (
  props: CreateSeedAudiencesDataSourceProps & { disabled: boolean }
) => {
  const { disabled, tab } = props;

  const isConnected = !disabled;

  const isCategoryShoppers = tab === 'categoryShoppers';
  const isCOLALs = tab === 'colal';

  return (
    <ContentContainer title="Data sources">
      <ContentWrapper>
        <ContentWrapper flow="column">
          <Text variant="body2Semibold">Shopify integration</Text>
          <CreateSeedAudiencesDataSourceConnectionBadge isConnected={isConnected} />
        </ContentWrapper>
        <CreateSeedAudiencesDataSourcesBrandCategory {...props} />
      </ContentWrapper>
      <Divider margin={16} />
      {isCategoryShoppers && <CreateSeedAudiencesDataSourcesCategoryShoppers {...props} />}
      {isCOLALs && <CreateSeedAudiencesDataSourcesCOLALs {...props} />}
    </ContentContainer>
  );
};

export default CreateSeedAudiencesDataSourcesView;
